import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { LayoutTypeFacet } from '../models/layouts/LayoutTypeFacet';
/**
 * @public
 */
export interface ISetDefaultLayoutPayload {
  itemsScopeItemKey: string;
  layoutType: LayoutTypeFacet;
}

export const itemsViewControl: ControlFacet<{
  itemsScopeItemKey: string;
  itemKey: string | undefined;
}, {
    setDefaultLayout: (payload: ISetDefaultLayoutPayload) => IItemCacheThunkAction<void>;
    defaultLayout: LayoutTypeFacet;
    pinnedItemsView: JSX.Element;
    additionalLayouts: JSX.Element[];
    isLayoutResolved: boolean;
    shouldShowEmptyFolder?: (payload: { layoutKey: string | undefined }) => boolean;
    shouldShowPinnedItems?: (payload: { layoutKey: string | undefined }) => boolean;
  }> = new ControlFacet('itemsViewControl');
